import PageWrapper from "../PageWrapper";
import {Container} from "@mantine/core";
import QRCodeView from "../../components/qr-code/view/QRCodeView";

/**
 * @author Kacper Faber
 * @since 0.1.1
 * @constructor
 */
function Index() {
    return (
        <PageWrapper>
            <Container mt="xl">
                <QRCodeView/>
            </Container>
        </PageWrapper>
    );
}

export default Index;

// TODO: Index.tsx
//  - implement index page.